import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomModal,
  InputDate,
  InputNumeroInteiro,
  InputPhone,
  InputText,
} from '../../../../../components'
import useMotoristaModal, { LOAD_MESSAGE } from './MotoristaModalHook'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

function MotoristaModal({ show, onModalClose, onModalSave, motorista, selectedTp, dispatch }) {
  const { state, localDispatch } = useMotoristaModal()
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (show) localDispatch.onInit(motorista)
  }, [motorista, show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_DRIVER:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveMotorista(state.motorista, selectedTp)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave({ ...state.savedMotorista })
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
  }, [state.errorMessage])

  return (
    <CustomModal header="Motorista" isVisible={show} onClose={onModalClose} width={600}>
      <form className="p-grid">
        <div className="p-col-8">
          <InputText
            label="Nome:*"
            value={localDispatch.validateValue(state.motorista.name)}
            onChange={value => localDispatch.onInputChange('name', value.toUpperCase())}
          />
        </div>
        <div className="p-col-4">
          <InputNumeroInteiro
            label="CPF:"
            value={localDispatch.validateValue(state.motorista.cpf)}
            onChange={value => localDispatch.onInputChange('cpf', value)}
            format="###.###.###-##"
          />
        </div>
        <div className="p-col-4">
          <InputText
            marginTop={9}
            label="Número da CNH:"
            value={localDispatch.validateValue(state.motorista.cnh_number)}
            onChange={value => localDispatch.onInputChange('cnh_number', value)}
          />
        </div>
        <div className="p-col-4">
          <InputText
            marginTop={9}
            label="Tipo da CNH:"
            value={localDispatch.validateValue(state.motorista.cnh_type)}
            onChange={value => localDispatch.onInputChange('cnh_type', value.toUpperCase())}
          />
        </div>
        <div className="p-col-4">
          <InputDate
            marginTop={9}
            label="Data Expiração da CNH:"
            value={localDispatch.validateValue(state.motorista.cnh_expiration)}
            onChange={value => localDispatch.onInputChange('cnh_expiration', value)}
          />
        </div>
        <div className="p-col-3">
          <InputPhone
            marginTop={9}
            label="Telefone de Contato:"
            value={localDispatch.validateValue(state.motorista.phone)}
            onChange={value => localDispatch.onInputChange('phone', value)}
            autoClear={false}
          />
        </div>
        <div className="p-col-9">
          <InputText
            marginTop={9}
            label="Endereço:"
            value={localDispatch.validateValue(state.motorista.address)}
            onChange={value => localDispatch.onInputChange('address', value.toUpperCase())}
          />
        </div>
        <div className="p-col-6">
          <InputDate
            marginTop={9}
            label="Data Expiração do Toxicológico:"
            value={localDispatch.validateValue(state.motorista.toxicologico_expiration)}
            onChange={value => localDispatch.onInputChange('toxicologico_expiration', value)}
          />
        </div>
        <div className="p-col-6">
          <div style={{ position: 'relative' }}>
            <InputText
              marginTop={9}
              type={showPassword ? 'text' : 'password'}
              label="Senha TpDrive"
              value={state.motorista.password}
              onChange={value => localDispatch.onInputChange('password', value)}
              inputStyle={{
                width: '100%',
                paddingRight: '4px',
              }}
            />

            <span
              onClick={() => setShowPassword(prev => !prev)}
              style={{
                position: 'absolute',
                right: '8px',
                top: 'calc(50% + 12px)',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 2,
                fontSize: '1.1rem',
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
        </div>

        <div className="p-col-3" style={{ margin: 'auto 0' }}>
          <CustomCheckbox
            checked={state.motorista.actived}
            onChange={value => localDispatch.onInputChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(MotoristaModal)
